import Vue from 'vue'
import Vuex from 'vuex'
import { getToken, parseJwt, pendoInitialize } from '@/helpers/authHelper'
import router from '@/router'

Vue.use(Vuex)

export interface State {
  email: string
  idpId: string
  isLearner: boolean
  isHiringManager: boolean
  isBusinessAdmin: boolean
  isMasqueradingReadOnly: boolean
}

export const ROLES = {
  learner: 'Learner',
  hiringManager: 'Hiring Manager',
  businessAdmin: 'Business Admin',
  masqueradingReadOnly: 'Masquerade Read-only'
}

export const ROLE_TO_ROLE_STATE = {
  [ROLES.learner]: 'isLearner',
  [ROLES.hiringManager]: 'isHiringManager',
  [ROLES.businessAdmin]: 'isBusinessAdmin',
  [ROLES.masqueradingReadOnly]: 'isMasqueradingReadOnly',
}

// If expanding to multiple states use modules
export const store = new Vuex.Store<State>({
  state (): State {
    return {
      email: '',
      idpId: '',
      isLearner: false,
      isHiringManager: false,
      isBusinessAdmin: false,
      isMasqueradingReadOnly: false,
    }
  },
  mutations: {
    updateEmail (state: State, next: string): void {
      state.email = next
    },
    updateRoles (state: State, next: string[]): void {
      Object.keys(ROLE_TO_ROLE_STATE).forEach(key => {
        state[ROLE_TO_ROLE_STATE[key]] = next.includes(key)
      })
    },
    updateIdpId (state: State, next: string): void {
      state.idpId = next
    }
  },
  actions: {
    updateFromTokens (context): void {
      const token = getToken()
      if (token) {
        const parsed = parseJwt(token)
        if (!parsed) {
          console.error('failed to load JWT')
          router.push({ name: 'Logout' })
        } else {
          const { email, roles, sub } = parsed
          context.commit('updateEmail', email)
          context.commit('updateRoles', roles)
          context.commit('updateIdpId', sub)
        }
      }
      // If token has updated, need to initialize pendo with new user info
      pendoInitialize()
    }
  }
})
